export const extractYoutubeVideoId = (url) => {
  const regex =
    /^.*(youtu\.be\/|shorts\/|embed\/|v\/|watch\?v=|&v=)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[2] : null;
};
